import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useEnsureValidSession } from "../auth/authorization";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth0();
  const ensureValidSession = useEnsureValidSession();
  const [checking, setChecking] = useState(true);
  const [valid, setValid] = useState(false);

  useEffect(() => {
    let cancelled = false;
    async function check() {
      if (!isAuthenticated) {
        if (!cancelled) {
          setValid(false);
          setChecking(false);
        }
        return;
      }
      try {
        const ok = await ensureValidSession();
        if (!cancelled) setValid(Boolean(ok));
      } catch (e) {
        if (!cancelled) setValid(false);
      } finally {
        if (!cancelled) setChecking(false);
      }
    }
    check();
    return () => { cancelled = true; };
  }, [isAuthenticated, ensureValidSession]);

  if (isLoading || checking) return <div>Loading�</div>;
  if (!isAuthenticated || !valid) return <Navigate to="/map" replace />;
  return children;
}